export const iconBoxData = [
    { icon: "sliders", header: "Sliders" },
    { icon: "user", header: "User" },
    { icon: "tags", header: "Tags" },
    { icon: "android", header: "Android" },
    { icon: "eye-slash", header: "Hidden" },
    { icon: "folder-open", header: "Folder" },
    { icon: "paper-plane", header: "Send" },
    { icon: "cloud-upload", header: "Upload" },
];

export const filledCheckBoxData = ["warning", "danger", "info"];

export const imagesWithData = [
    { tittle: "Custom" },
    { tittle: "Checked Image", defaultChecked: true },
    { tittle: "Disable Image", disabled: true },
    { tittle: "Disable Checked Image", disabled: true, defaultChecked: true },
  ];

export const iconRadioBoxData = [
{ name: "Koho", color: "secondary" },
{ name: "Roxo", color: "success" },
{ name: "Voxo", color: "warning" },
{ name: "Zeta", color: "info" },
];

export const filledRadioData = [
    { heading: "Product", colorName: "primary" },
    { heading: "Order history", colorName: "warning" },
    { heading: "Invoice", colorName: "danger" },
    { heading: "Wishlist", colorName: "info" },
  ];

  export const inlineCheckboxData = [
    { tittle: "I", defaultChecked: true },
    { tittle: "II" },
    { tittle: "III (disabled)", disabled: true },
  ];

  export const inlineRadioBoxData = [
    { tittle: "1", defaultChecked: true },
    { tittle: "2" },
    { tittle: "3(disabled)", disabled: true },
  ];

  export const inlineSwitchesData = [
    { defaultChecked: true },
    { defaultChecked: false },
    { disabled: true },
  ];

  export const paymentMethodName = ["Visa", "MasterCard", "Paypal", "G-pay", "Bitpay"];

 export const favoriteSocialMediaItems = ["Instagram","Facebook","Whatsapp","Twitter",];

 export const simpleCheckboxNames = ["Blog", "Gallery", "Faq", "Email", "Icons"];

 export const simpleRadioBoxNames = ["Maps", "Tasks", "To-do", "Forms", "Login"];

 export const radioToggleButtonsData = ["Checked", "Radio", "Disabled", "Radio"];
 
 export const outLineCheckBoxData = [
    { className: "info", name: "Single toggle" },
    { className: "danger", name: "Checked", defaultChecked: true },
    {
      className: "success",
      name: "Checked success radio",
      defaultChecked: true,
    },
    { className: "dark", name: "Dark radio" },
  ];